import { DifficultWord } from "../types";
import ApiModule from "./base";

export default class DifficultWordsModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "difficult_words");
  }

  async index(): Promise<Array<DifficultWord>> {
    const request = new Request(this.url, {
      method: "GET",
      headers: this._defaultHeaders(),
    });
    return await this._resolve(request);
  }
}
